import { render, staticRenderFns } from "./Metropoli.vue?vue&type=template&id=1e5173e2&scoped=true&"
import script from "./Metropoli.vue?vue&type=script&lang=js&"
export * from "./Metropoli.vue?vue&type=script&lang=js&"
import style0 from "./Metropoli.vue?vue&type=style&index=0&id=1e5173e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5173e2",
  null
  
)

export default component.exports